import { PathOptions } from "leaflet";

export const unidades_conservacao_ambiental = (feature: any): PathOptions => {
  const grupo = feature?.properties?.grupo4;

  if (grupo === "PI" || grupo === "Proteção Integral") {
    return {
      fillColor: "#267319",
      color: "#26660d",
      weight: 0.5,
      fillOpacity: 0.7,
    };
  }

  if (grupo === "US" || grupo === "Uso Sustentável") {
    return {
      fillColor: "#b4d79e",
      color: "#99bf80",
      weight: 0.5,
      fillOpacity: 0.7,
    };
  }

  return {
    fillColor: "#ccc",
    color: "#999",
    weight: 0.5,
    fillOpacity: 0.5,
  };
};
